A suggested location.
